import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import { 
	FacebookShareButton, 
	TwitterShareButton
} from "react-share";
import { useSnackbar } from 'notistack';

import guestService from '../../services/guestService';
import ErrorValidationAlert from '../alerts/ErrorValidationAlert';

const SocialShareBtns = (props) => {

    const [errors, setErrors] = useState("");
    const { enqueueSnackbar } = useSnackbar();

    const handleSocialShare = (listId, platform, url) => {

        setErrors("");

        const formData = new FormData();            
        formData.append('listing_id', listId)
        formData.append('platform', platform)
        formData.append('url', url)

        guestService.shareListingOnSocialPlatform(formData)
                .then((res) => {
                    if(res.data.success) {
                        enqueueSnackbar(res.data.message, {
                            variant: 'success',
                            autoHideDuration: 5000,
                        });
                     //   props.setDialogIsOpen(false)
                    }
                })
                .catch((error) => {
                    if(error) {
                        setErrors(error.response.data.errors)
                        enqueueSnackbar('Woops! Something went wrong!', {
                            variant: 'error',
                            autoHideDuration: 5000,
                        });
                    }
                })
    }

    return (
        <>
            {errors &&
                <ErrorValidationAlert
                    errors={errors} 
                />
            }

            <div className="row no-gutters my-2">
                <div className="col-md-6 col-sm-6 col-xs-12 pr-1">
                    <Button 
                        color="primary" 
                        variant="contained" 
                        size="large"
                        style={{ textTransform: 'none' }} 
                        startIcon={<FacebookIcon />} 
                        fullWidth
                    >
                        <FacebookShareButton 
                            url={props.url}
                            quote={props.listing.title}
                            hashtag={`#${props.listing.title}`}
                            onShareWindowClose={() => handleSocialShare(props.listing.id, 'facebook', props.url)}
                        >
                            Share on Facebook
                        </FacebookShareButton>
                    </Button>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12 pl-1">
                    <Button 
                        color="primary" 
                        variant="contained" 
                        size="large" 
                        style={{ textTransform: 'none' }} 
                        startIcon={<TwitterIcon />}
                        fullWidth
                    >
                        <TwitterShareButton
                            url={props.url}
                            title={props.listing.title}
                            hashtags={props.listing.tags}
                            onShareWindowClose={() => handleSocialShare(props.listing.id, 'twitter', props.url)}	
                        >
                            Share on Twitter
                        </TwitterShareButton>
                    </Button>
                </div>
            </div>
        </>
    );
};

export default SocialShareBtns;